<template>
  <Overlay :show="show">
    <div class="wrapper" @click.stop>
      <div class="block">
        <div class="title">请输入您的用户昵称</div>
        <Field
          v-model="form.nickname"
          :rules="[{ required: true, message: '请填写用户昵称' }]"
        />
        <Button block @click="confirm">确认</Button>
      </div>
    </div>
  </Overlay>
</template>

<script>
import { Overlay, Field, Button, Toast } from 'vant'
import { setNickname } from '@/api/login'
import { getInfo } from '@/api/setting'
export default {
  components: { Overlay, Field, Button },
  data() {
    return {
      show: false,
      form: {
        nickname: null
      }
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.init()
      },
      immediate: true,
    },
  },
  methods: {
    init() {
      if (this.$store.state.user.customerId && !this.$store.state.user.userInfoNickname) {
        this.show = true
      }
    },
    confirm() {
      const nickname = this.form.nickname.trim()
      if (nickname) {
        this.$store.dispatch('app/showLoading')
        setNickname({ name: nickname }).then(res => {
          this.$store.dispatch('app/hideLoading')
          this.$store.dispatch('user/getUserInfoDetail', this.$store.state.user.customerId)
          Toast.success('设置成功')
          this.show = false
        }).catch(() => {
          this.$store.dispatch('app/hideLoading')
        })
      } else {
        Toast.fail('请输入您的用户昵称')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.van-overlay {
  z-index: 999;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .block {
    width: 592px;
    background: #FFFFFF;
    padding: 0 20px 20px;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    overflow: hidden;
    .title {
      padding: 20px 0;
      font-size: 28px;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
    }
    .van-cell {
      background: #F1F1F1;
      border-radius: 6px;
      padding: 10px 20px;
    }
    .van-button {
      margin-top: 20px;
      background: linear-gradient(135deg, #E82237 0%, #FF9D9D 100%);
      border-radius: 6px;
      border: 2px solid #FE6979;
      font-size: 28px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 28px;
      height: 68px;
    }
  }
}
</style>